import {
  ArrowDownToLine,
  ArrowUpFromLine,
  LayoutDashboard,
  LifeBuoy,
  type LucideIcon,
  Package,
  Settings,
  TrendingUp,
  Users,
  Wallet2,
} from 'lucide-react';

export interface NavLinkItem {
  label: string;
  to: string;
}

export interface NavGroupItem {
  label: string;
  icon: LucideIcon;
  /** A group with no children renders as a single top-level link. */
  to?: string;
  items?: NavLinkItem[];
}

/**
 * Admin sidebar. Mirrors the screen inventory in §7 — the panel STRUCTURE is
 * carried over; the income taxonomy underneath it is Alpha One's (§8).
 */
export const adminNav: NavGroupItem[] = [
  { label: 'Dashboard', icon: LayoutDashboard, to: '/' },
  {
    label: 'Members',
    icon: Users,
    items: [
      { label: 'All Members', to: '/members/all' },
      { label: 'Active', to: '/members/active' },
      { label: 'Inactive', to: '/members/inactive' },
      { label: 'Blocked', to: '/members/blocked' },
      { label: 'Search', to: '/members/search' },
      { label: 'Binary Tree', to: '/members/binary-tree' },
      { label: 'Virtual Power', to: '/members/virtual-power' },
      { label: 'Add to Wallet', to: '/members/wallet/add' },
      { label: 'Deduct from Wallet', to: '/members/wallet/deduct' },
    ],
  },
  {
    label: 'Deposits',
    icon: ArrowDownToLine,
    items: [
      { label: 'Pending', to: '/deposits/pending' },
      { label: 'Approved', to: '/deposits/approved' },
      { label: 'Rejected', to: '/deposits/rejected' },
      { label: 'All Deposits', to: '/deposits/all' },
      { label: 'Blockchain (DApp)', to: '/deposits/blockchain' },
    ],
  },
  {
    label: 'DApp Requests',
    icon: Wallet2,
    items: [
      { label: 'Pending', to: '/dapp-requests/pending' },
      { label: 'Confirmed', to: '/dapp-requests/confirmed' },
      { label: 'Rejected', to: '/dapp-requests/rejected' },
      { label: 'All Requests', to: '/dapp-requests/all' },
    ],
  },
  {
    label: 'Incomes',
    icon: TrendingUp,
    items: [
      { label: 'All Income', to: '/income/all' },
      { label: 'Direct Referral', to: '/income/direct-referral' },
      { label: 'Level Income', to: '/income/level-income' },
      { label: 'Alpha Club A', to: '/income/alpha-club-a' },
      { label: 'Alpha Club B', to: '/income/alpha-club-b' },
      { label: 'Elite Rank', to: '/income/elite-rank' },
      { label: 'Achievement Rewards', to: '/income/achievement-reward' },
    ],
  },
  {
    label: 'Withdrawals',
    icon: ArrowUpFromLine,
    items: [
      { label: 'Pending', to: '/withdrawals/pending' },
      { label: 'Approved', to: '/withdrawals/approved' },
      { label: 'Rejected', to: '/withdrawals/rejected' },
      { label: 'Reports', to: '/withdrawals/reports' },
      { label: 'Auto Withdrawal', to: '/withdrawals/auto' },
    ],
  },
  { label: 'Support', icon: LifeBuoy, to: '/tickets' },
  { label: 'Packages', icon: Package, to: '/packages' },
  {
    label: 'System',
    icon: Settings,
    items: [
      { label: 'News', to: '/system/news' },
      { label: 'Settings', to: '/system/settings' },
      { label: 'Cron Monitor', to: '/system/cron-log' },
    ],
  },
];
